export const arrayToPlayablesObject = (items) =>
  items?.reduce((acc, item) => {
    acc[item.id] = item;
    return acc;
  }, {});
